import { css } from '@emotion/core';
import ColorIconButton from 'components/color-icon-button';
import ColorPickerPopover, { ColorValuesMap } from 'components/color-picker-popover';
import DefaultColorPopoverInput from 'components/default-color-popover-input';
import { useState } from 'react';
import _ from 'underscore';
import { LectureComponentProps } from '..';

/** Wraps the ColorPickerPopover for use in a header lecture component text area.  */
const HeaderColorPickerPopover = (props: {
  currentLecture: LectureComponentProps['currentLecture'],
  colorValues: ColorValuesMap,
  inputLabels: Record<string, string>,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  return (
    <ColorPickerPopover
      show={showColorPicker}
      placement='top-end'
      currentLecture={props.currentLecture}
      renderContent={({ getColorInputProps }) => (
        <div>
          {_.keys(props.colorValues).map((key, i) => (
            <div key={key} className={i === 0 ? 'mb-4' : ''}>
              <DefaultColorPopoverInput
                name={key}
                getColorInputProps={getColorInputProps}
                label={props.inputLabels[key]}
              />
            </div>
          ))}
        </div>
      )}
      colorValues={props.colorValues}
      onToggle={(nextShow) => { setShowColorPicker(nextShow); }}
    >
      <div className={`icon-btn-container ${showColorPicker ? 'picker-visible' : ''}`}>
        <ColorIconButton tooltip={!showColorPicker && 'Edit Colors for this Header'} />
      </div>
    </ColorPickerPopover>
  );
};

export default HeaderColorPickerPopover;
